import { render } from "./PackagesCard.vue?vue&type=template&id=10af6e84&scoped=true"
import script from "./PackagesCard.vue?vue&type=script&lang=js"
export * from "./PackagesCard.vue?vue&type=script&lang=js"

import "./PackagesCard.vue?vue&type=style&index=0&id=10af6e84&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10af6e84"]])

export default __exports__